import React, {ReactNode, useEffect, useRef, useState} from 'react';
import InfoPopover from "@components/popover/infoPopover.component";

interface TruncateTextProps extends React.HTMLAttributes<HTMLDivElement> {
    lines?: number,
    width?: number,
    infoPopoverContent?: HTMLElement | string,
    children?: ReactNode
}

const TruncateText: React.FC<TruncateTextProps> = ({lines, width, infoPopoverContent, children, ...props}: TruncateTextProps) => {
    const textRef = useRef<HTMLDivElement>(null);

    const [isTruncated, setIsTruncated] = useState(false);

    const truncateTextStyle: React.CSSProperties = {
        overflow: "hidden",
        textOverflow: "ellipsis",
    };

    useEffect(() => {
        if (textRef.current) {
            const el = textRef.current;
            const truncated = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
            setIsTruncated(truncated);
        }
    }, [children, lines, width]);

    if (typeof lines === "number") {
        truncateTextStyle.display = "-webkit-box";
        truncateTextStyle.WebkitBoxOrient = "vertical";
        truncateTextStyle.WebkitLineClamp = lines;
    }

    if (typeof width === "number") {
        truncateTextStyle.width = `${width}px`;
        truncateTextStyle.whiteSpace = "nowrap";
    }

    return (
        <div
            style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}
        >
            <div ref={textRef} style={truncateTextStyle} {...props}>
                {children}
            </div>
            {
                isTruncated && infoPopoverContent && <InfoPopover content={infoPopoverContent}/>
            }
        </div>
    );
};

export default TruncateText;